import { HelpCircle } from 'lucide-react';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from '../ui/dialog';
import { ConstanciaSemanasMockup, AforeEstadoCuentaMockup } from './DocumentMockups';

export function DocumentFieldHelp({ docType, highlight, title, description }) {
  const Mockup = docType === 'afore' ? AforeEstadoCuentaMockup : ConstanciaSemanasMockup;

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="sm"
          className="h-auto p-0 gap-1 text-xs font-normal text-[#2563EB] hover:text-[#1D4ED8] hover:bg-transparent"
          data-testid={`field-help-${highlight}`}
        >
          <HelpCircle className="w-3.5 h-3.5" />
          ¿Dónde lo encuentro?
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle className="font-['Manrope']">{title}</DialogTitle>
          {description && <DialogDescription>{description}</DialogDescription>}
        </DialogHeader>
        <Mockup highlight={highlight} />
      </DialogContent>
    </Dialog>
  );
}
